import events_data from '../data/events.json'
import { ICalCalendar } from 'ical-generator';

export function isDateInPast(targetDate) {
    const now = new Date(); // Get the current date and time
    const target = new Date(targetDate); // Convert the input to a Date object 
    // Compare the target date with the current date
    // If target.getTime() is less than now.getTime(), the target date is in the past

    const isPast = target.getTime() < now.getTime();
    console.log('isDateInPast returning ' + isPast + 'for given time ' + targetDate)
    return isPast
}

export async function get_events(include_unpublished) {
    const data = events_data.events
    const status = 200
    if (include_unpublished === true) {
        return { status, data }
    }
    const filtered_data = data.filter((x) => x.is_published);
    return { status, 'data': filtered_data }
}

export async function get_future_events(filter_unpublished) {
    const data = events_data.events
    const status = 200
    let filtered_data = data.filter((x) => !isDateInPast(x.end_time));
    if (filter_unpublished === true) {
        filtered_data = filtered_data.filter((x) => x.is_published);
    }
    return { status, 'data': filtered_data }
}

const filter_on_properties = (x, properties) => {
    for (const key in properties) {
        if (Object.prototype.hasOwnProperty.call(properties, key)) {
            console.log(key, properties[key], x[key]); // Output: a, b, c
            const isNotMatch = x[key] !== properties[key]
            console.log('isMatch: ' + isNotMatch)
            if (isNotMatch) {
                return false
            }
        }
    }
    return true
}

export async function get_future_events_with_filters(filters) {
    const data = events_data.events
    const status = 200

    const filtered_data = data.filter((x) => (!isDateInPast(x.end_time) && filter_on_properties(x, filters)));

    return { status, 'data': filtered_data }
}

export async function get_highlighted_events() {
    const data = events_data.events
    const status = 200
    const filtered_data = data.filter((x) => (x.is_highlighted && !isDateInPast(x.end_time)));
    console.log('filtered_data : ' + JSON.stringify(filtered_data))
    return { status, 'data': filtered_data }
}

export function create_cal_event(event) {
    const cal = new ICalCalendar({ name: 'My Event Calendar' });
    cal.createEvent({
        start: new Date(event.start_time),
        end: new Date(event.end_time),
        summary: event.summary,
        description: event.description,
        location: event.location,
    });
    return cal
}

